import { render, staticRenderFns } from "./activityDecoration.vue?vue&type=template&id=cdf8848c&"
import script from "./activityDecoration.vue?vue&type=script&lang=js&"
export * from "./activityDecoration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports